import React from "react";
import IntFileDetail from "../component/IntFileDetail";

const IntFileDetailContainer = ({ pageId }) => (<IntFileDetail pageId={pageId}/>)

export default IntFileDetailContainer;
